import React, { useState } from "react";
import "../../styles/BuildingPreviews/BuildingPreview.css"; // Ensure proper styling

const BuildingPreview = ({ building, onClose, onViewDetails }) => {
  return (
    <div style={{ padding: "10px", borderRadius: "8px", background: "white" }}>
      <h3>{building.Address}</h3>
      <p>
        {building.City}, {building.State}
      </p>
      <button onClick={() => onViewDetails(building)}>View Details</button> {/* Button triggers detailed view */}
      <button onClick={onClose}>Close</button>
    </div>
  );
};

export default BuildingPreview;